import axios, { type AxiosRequestConfig, type AxiosResponse, type AxiosStatic } from 'axios';

export default {
  ...axios,
  get: async <T = unknown, R = AxiosResponse<T>, D = unknown, P = unknown>(url: string, config?: AxiosRequestConfig<D, P>) => {
    const params = { _: Date.now(), ...config?.params } as P;
    const headers = { 'X-Requested-With': 'XMLHttpRequest', ...config?.headers };
    try {
      return await axios.get<T, R, D, P>(url, config ? { ...config, params, headers } : { params, headers });
    } catch (error) {
      // response がない（ネットワークエラー等）場合と、400/500系のみ捕捉し、300系のリダイレクトは無視する
      if (window.Sentry && (!error.response || error.response.status >= 400)) {
        window.Sentry.captureException(error);
      }
      throw error;
    }
  },
} as AxiosStatic;
